let PLATFORM = 1;
let MAIN_CLASS = 'main_mfd';

let url = window.location.href;

let mfd = 'mifengdao';
let kjc = 'kuaijichong';
let localhost = 'localhost';

//环境判断
if (url.indexOf(kjc) != -1) {
  PLATFORM = 2;
  MAIN_CLASS = 'main_kjc';
} else if (url.indexOf(localhost) != -1) {
  PLATFORM = 1;
  MAIN_CLASS = 'main_mfd';
} else {
  PLATFORM = 1;
  MAIN_CLASS = 'main_mfd';
}

export default {
  PLATFORM,
  MAIN_CLASS
}
